module.exports = "./dist/DINPro-Bold.otf?78c60ee2ca750efc1fbd55f882505465";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/DINPro-Bold.otf
// module id = 6
// module chunks = 0